import React from 'react';
import { Layout } from 'antd';
import FooterComponent from '../components/Footer/FooterComponent';
import AppHeader from '../components/Header/AppHeader';
import SideMenu from '../components/SideMenu/SideMenu';

const { Content } = Layout;

const BasePage = ({ children }) => {
    return (
        <Layout style={{ height: '100vh', width: '100%', overflow: 'hidden' }}>
            <SideMenu />
            <Layout style={{ width: '100%', overflow: 'hidden' }}>
                <AppHeader />
                <Content
                    style={{
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        padding: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        width: '100%',
                        maxWidth: '100%',
                    }}
                >
                    <div style={{ flex: 1, width: '100%', maxWidth: '100%' }}>
                        {children}
                    </div>
                    <FooterComponent />
                </Content>
            </Layout>
        </Layout>
    );
};

export default BasePage;
